<template>
  <div
    id="SecondaryDeviceEdit"
    class="h-100 p-10 position-absolute"
    :style="{ height: height, top: top }"
  >
    <div class="secondary_title w-100 m-b-10">
      <span class="fz-14">二次设备编辑</span>
      <span class="iconfont cur_pointer r icon-close fz-12" @click="closeComponent"></span>
    </div>
    <div class="chose_operate" v-if="isTags">
      <el-button
        v-for="(item, index) in choseValue"
        :key="index"
        type="primary"
        size="small"
        @click="choseComponents(item.value)"
        >{{ item.name }}</el-button
      >
    </div>
    <div
      class="model_operate m-t-10 m-b-10 w-100"
      :style="{ height: isTags ? 'calc(100% - 65px)' : 'calc(100% - 35px)' }"
    >
      <component
        :is="componentId"
        :updateNode="updateNodeInfo"
        :watchNodeModify="watchNodeModify"
        :isShowTags="isTags"
        :player="player"
        :currentNodeData="propsNodeData"
        @getTags="getTags"
        @cancleModify="cancleModify"
        @updateEditTree="updateEditTree"
      >
      </component>
    </div>
  </div>
</template>
<script>
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { isJSONObj } from '../../js/engineerSceneData'

const Cabinet = () => {
  return import('./secondaryDeviceEdit/Cabinet')
}
const TerminalBlocks = () => {
  return import('./secondaryDeviceEdit/TerminalBlocks')
}
const InstrumentList = () => {
  return import('./secondaryDeviceEdit/InstrumentList')
}
const SwitchList = () => {
  return import('./secondaryDeviceEdit/SwitchList')
}
const TagList = () => {
  return import('./secondaryDeviceEdit/TagList')
}
const Platen = () => {
  return import('./secondaryDeviceEdit/Platen')
}
export default {
  name: 'SecondaryDeviceEdit',
  props: ['documentId', 'player', 'height', 'top', 'currentNodeData', 'watchNodeModify'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  components: {
    Cabinet,
    TerminalBlocks,
    SwitchList,
    TagList,
    Platen,
    InstrumentList,
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  watch: {
    currentNodeData: {
      handler(val) {
        this.$nextTick(() => {
          if (isJSONObj(val.code) && JSON.parse(val.code).type === 'Cabinet') {
            this.propsNodeData = _.cloneDeep(val)
          }
        })
      },
      deep: true,
    },
    watchNodeModify: {
      handler(val) {
        this.$nextTick(async () => {
          if (_.isNil(val.node)) {
            // 从模型树的上拿到根节点
            const rootItem = await this.player.Native.ModelTree.getRootItems()
            // 在跟节点集合中查找我们设置的场景的跟节点
            const rootNode = _.find(rootItem, (val) => {
              return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
            })
            // 获取当前选中模型子级
            const subNodes = await this.player.Native.NodeProxy.getNodeChildren(rootNode.nodePtr)
            const currentNode = _.find(subNodes, (item) => {
              return item.nodePtr === this.propsNodeData.nodePtr
            })
            if (_.isNil(currentNode)) {
              this.propsNodeData = {}
            }
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.propsNodeData = _.cloneDeep(this.currentNodeData)
  },
  methods: {
    // 子组件更新节点
    async updateEditTree(node) {
      const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(node)
      if (isJSONObj(nodeInfo.code) && JSON.parse(nodeInfo.code).type === 'Cabinet') {
        this.propsNodeData = nodeInfo
      }
      this.$emit('updateEditTree', node)
    },
    // 组件切换
    choseComponents(val) {
      console.log(val)
      this.isTags = true
      this.componentId = val
    },
    // 取消编辑机柜
    cancleModify() {
      this.propsNodeData = {}
      this.isTags = false
    },
    //
    getTags(val) {
      this.isTags = val
    },
    //
    createdNewModel() {},
    // 关闭弹窗
    closeComponent() {
      this.$emit('closeComponent', 'SecondaryDeviceEdit')
    },
  },
  data() {
    return {
      propsNodeData: {},
      currentTagFile: {},
      defaultTagFolderId: '', // 标签文件夹路径
      tagDataList: [], // 标签列表
      isTags: false,
      // 更新后的节点
      updateNodeInfo: null,
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      choseValue: [
        { name: '机柜', value: 'Cabinet' },
        { name: '仪器', value: 'InstrumentList' },
        { name: '端子排', value: 'TerminalBlocks' },
        { name: '压板', value: 'Platen' },
        { name: '标签', value: 'TagList' },
        { name: '开关', value: 'SwitchList' },
      ],
      componentId: 'Cabinet',
    }
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/index.scss';
@import '../../css/select.scss';
#SecondaryDeviceEdit {
  color: #fff;
  z-index: 99;
  width: 468px;
  background-color: rgba(46, 107, 176, 0.5) !important;
  transition: left 0.3s;
  border-radius: 2px;
  right: 35px;
  height: 600px;
}
/deep/.player_progress {
  position: fixed !important;
}
.chose_operate {
  display: flex;
  justify-content: space-between;
  /deep/.el-button--small {
    padding: 8px 9px !important;
  }
}
.model_operate {
  overflow: auto;
  height: calc(100% - 65px);
  background-color: transparent;
}
.point_set {
  .el-radio {
    margin-right: 10px;
    color: #fff;
  }
  .el-button {
    float: right;
  }
  .el-select {
    width: 50px;
    height: 24px;
    /deep/.el-input--suffix {
      width: 50px !important;
      height: 24px !important;
      input {
        font-size: 12px;
      }
    }
    /deep/.el-input__inner {
      width: 50px !important;
      height: 24px !important;
      padding: 0 5px !important;
      color: #fff;
      background: none;
      text-align: center;
    }
    /deep/.el-input__suffix {
      display: none;
    }
  }
}

</style>
